import { useUnit } from 'effector-react'
import type React from 'react'
import { Form } from 'react-aria-components'

import { css } from '@portal/styled-system/css'

import { PasswordRequirementList } from '@/features/password-requirement'
import { env, isFeatureEnabled } from '@/shared/config'
import { useI18n } from '@/shared/lib/i18n'
import { Button, ButtonPlainBack } from '@/shared/ui'

import { PasswordInputField } from '../input-field'
import * as model from '../model'
import * as steps from '../steps'

export function SignupStepPassword() {
    const passwordLongEnough = useUnit(model.$passwordLongEnough)
    const passwordHasLowerAndUppercase = useUnit(model.$passwordHasLowerAndUppercase)
    const passwordHasDigitOrSpecialCharacter = useUnit(model.$passwordHasDigitOrSpecialCharacter)
    const signupFormSubmitted = useUnit(model.signupFormSubmitted)

    const handleFormSubmit = (e: React.SyntheticEvent<HTMLFormElement>) => {
        e.preventDefault()

        signupFormSubmitted({ skipValidation: false })
    }

    return (
        <div className={css({ width: 'full' })}>
            <Form
                method="post"
                onSubmit={handleFormSubmit}
                className={css({ display: 'flex', flexDirection: 'column', width: 'full' })}
            >
                <PasswordInput />

                <PasswordRequirementList
                    passwordLongEnough={passwordLongEnough}
                    passwordHasLowerAndUppercase={passwordHasLowerAndUppercase}
                    passwordHasDigitOrSpecialCharacter={passwordHasDigitOrSpecialCharacter}
                />

                <div className={css({ paddingTop: '4' })}>
                    <SignupButton />
                </div>
            </Form>
            <div className={css({ display: 'flex', justifyContent: 'center', paddingTop: '1' })}>
                <BackButton />
            </div>
        </div>
    )
}

function SignupButton() {
    const { i18n } = useI18n()

    const nonInteractive = useUnit(model.$interactionDisabled)

    const isPasswordWeak = useUnit(model.$isPasswordWeak)
    const isPasswordShort = useUnit(model.$isPasswordShort)
    const disabled = isFeatureEnabled('strong-password-validation') ? isPasswordWeak : isPasswordShort

    return (
        <Button color="cyan" type="submit" isDisabled={nonInteractive || disabled}>
            {i18n.BUTTON_SIGNUP}
        </Button>
    )
}

function PasswordInput() {
    const { i18n } = useI18n()

    const nonInteractive = useUnit(model.$interactionDisabled)

    return (
        <PasswordInputField
            name="password"
            placeholder={i18n.USER_PASSWORD}
            autoComplete="new-password"
            required
            isDisabled={nonInteractive}
            autoFocus
            minLength={env.ACCOUNT_PASSWORD_MIN_LEN}
            maxLength={env.ACCOUNT_PASSWORD_MAX_LEN}
        />
    )
}

function BackButton() {
    const { i18n } = useI18n()

    const handleBackButtonClick = () => {
        steps.showStepSignupEmail()
    }

    return (
        <ButtonPlainBack onPress={handleBackButtonClick}>
            <i className="fa-light fa-arrow-left-long" />
            &nbsp;{i18n.BTN_BACK}
        </ButtonPlainBack>
    )
}
